# Deps
import Vue from 'vue'

# Inject a helper like the nuxt/gtm package
window.dataLayer = [] unless window.dataLayer
Vue.prototype.$gtm = push: (payload) ->
	window.dataLayer.push payload
